export default {
    CONTENT_CARD_SESSION: 'CONTENT_CARD_SESSION'
};
